



<div class="row home-page no-gutters">
  <div *ngIf="isLoad; then LoadedBlock else Loading"></div>
  <ng-template #LoadedBlock>
    <div class="col-12">
      <!-- <app-offline-header>
      </app-offline-header> -->
    </div>
    <div class="col-12">
      <router-outlet></router-outlet>
    </div>
    <div class="col-12">
      <div></div>
    </div>
  </ng-template>
  <ng-template #Loading></ng-template>
</div>
